import * as types from './mutation_types'

export default {
  [types.RESET] (state) {
    Object.assign(state, {
      error: '',
      isLoading: false,
      retrieved: null,
      updated: null,
      violations: null
    })
  },

  [types.SET_ERROR] (state, error) {
    Object.assign(state, { error })
  },

  [types.TOGGLE_LOADING] (state) {
    Object.assign(state, { isLoading: !state.isLoading })
  },

  [types.SET_RETRIEVED] (state, retrieved) {
    retrieved.userDataTags = retrieved.userDataTags.map(tag => {
      return {
        idUserData: retrieved['@id'],
        '@id': tag['@id'],
        idTag: tag.idTag['@id'],
        value: tag.idTag['@id'],
        text: tag.idTag.tag
      }
    })

    if (retrieved.idClientType && retrieved.idClientType['@id']) {
      retrieved.idClientType = retrieved.idClientType['@id']
    }
    if (retrieved.workplace && retrieved.workplace['@id']) {
      retrieved.workplace = retrieved.workplace['@id']
    }
    if (retrieved.status && retrieved.status['@id']) {
      retrieved.status = retrieved.status['@id']
    }
    if (retrieved.salesOpportunity && retrieved.salesOpportunity['@id']) {
      retrieved.salesOpportunity = retrieved.salesOpportunity['@id']
    }
    if (retrieved.idEmployer && retrieved.idEmployer['@id']) {
      retrieved.idEmployer = retrieved.idEmployer['@id']
    }
    if (retrieved.idSalesRepresentative && retrieved.idSalesRepresentative['@id']) {
      retrieved.idSalesRepresentative = retrieved.idSalesRepresentative['@id']
    }
    if (retrieved.userDataEmployees) {
      delete retrieved.userDataEmployees
    }
    if (retrieved.firmEmployees) {
      delete retrieved.firmEmployees
    }
    if (retrieved.userDataFirms) {
      delete retrieved.userDataFirms
    }
    if (retrieved.users) {
      delete retrieved.users
    }

    Object.assign(state, { retrieved })
  },

  [types.SET_UPDATED] (state, updated) {
    Object.assign(state, { error: '', updated, violations: null })
  },

  [types.SET_VIOLATIONS] (state, violations) {
    Object.assign(state, { violations })
  },

  [types.UPDATE_RETRIEVED] (state, updated) {
    Object.assign(state.retrieved, updated)
  },

  [types.HANDLE_UPDATE] (state) {
    state.retrieved.userDataTags.forEach(tag => {
      if (!tag['@id']) {
        tag.idUserData = state.retrieved['@id']
        tag.idTag = tag.value
      }
    })
  }
}
